import React, {
  useEffect,
  Suspense,
  memo,
} from 'react';
import { get } from 'lodash';
import { Route } from 'react-router-dom';
import { innerRoutes as routes } from './routes';
import AppProvider from './store/context';
import CommonLoading from './Components/CommonLoading/CommonLoading';
import HasBasePath from './Components/HasBasePath';
import ThemeProvider from '@fil-react-components/theme-provider';
import { chBasedTheme } from './store/theme';
import './index.scss';
import './App.scss';

function App(props: any) {
  /* istanbul ignore next */
  useEffect(() => {
    const scrollEnable = document.querySelectorAll(
      'body.ReactModal__Body--open'
    );
    [].forEach.call(scrollEnable, (item: Element) => {
      item?.classList?.remove('ReactModal__Body--open');
    });
  }, []);

  useEffect(() => {
    window.parent.postMessage({ identifier: 'cloud-vault' }, '*');
  }, []);
  return (
    <ThemeProvider theme={chBasedTheme(get(props, 'ch', null))}>
      <AppProvider {...props}>
        <Suspense fallback={<CommonLoading />}>
          <HasBasePath
            baseName={props?.basePath}
            location={props?.history?.location}
            history={props?.history}
          >
            {routes.map((route) => {
              const Component = route.component;
              const path = `${route.path}`;
              return (
                <Route key={route.path} path={path}>
                  <Component />
                </Route>
              );
            })}
          </HasBasePath>
        </Suspense>
      </AppProvider>
    </ThemeProvider>
  );
}

const AppWithContext = memo(App);
export { App };
export default AppWithContext;
export const CloudVault = AppWithContext;
